import { render, staticRenderFns } from "./CustomRadioButtonGroup.vue?vue&type=template&id=6544d774&scoped=true"
import script from "./CustomRadioButtonGroup.vue?vue&type=script&lang=js"
export * from "./CustomRadioButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6544d774",
  null
  
)

export default component.exports